require('../../fhApp/appMetaService');
require('../../shared/singleGameService');
require('../../shared/singleClipService');

"use strict";

angular.module('app.player.jwPlayer.jwPlayerController', [
  'app.appMetaService',
  'app.shared.singleGameService',
  'app.shared.singleClipService',
  'app.constants'
])
  .controller('app.player.jwPlayer.jwPlayerController', [
    '$scope',
    'appMetaService',
    'app.shared.singleGameService',
    'app.shared.singleClipService',
    '$interval',
    '$timeout',
    '$state',
    'JW_PLAYER_KEY',
    'PLAYER_POSTERS',
    '$rootScope',
    '$cookies',
    function ($scope, appMeta, singleGame, singleClip, $interval, $timeout, $state, JW_PLAYER_KEY, playerPosters, $rootScope, $cookies) {
      let gameReady = !!(singleGame.data && singleGame.data.igameid);
      let domReady = false;
      let eventListeners = [];
      let currentGame = null;
      let playerReady = false;
      let preGameState = false;

      $scope.disableEventButtons = $scope.disableEventButtons || false;
      $scope.hideEventButtons = $scope.hideEventButtons || false;
      $scope.id = $scope.id || null;
      $scope.player = null;
      $scope.playerRenderingMode = null;
      $scope.singleClip = singleClip;
      $scope.showVideoControls = false;
      $scope.theatreMode = false;
      $scope.playerError = null;
      $scope.refreshPlayerInterval = null;

      $scope.watchedGameId = null;
      $scope.trackWatchingInterval = null;
      $scope.trackWatchingIntervalTime = 60000;

      let loadMedia = function () {
        if (domReady && gameReady) {
          let audio = $scope.selectedAudio;
          if (!audio && singleClip && singleClip.data) {
            audio = singleClip.data.audio;
          }
          let promise = singleGame.getStreamUrl(audio);

          if (promise) {
            promise.then(function (response) {
              if (singleGame.data.igameid !== currentGame || preGameState) {
                // If the scheduled start time is within 1 hour, we will consider it starting soon
                let gameStartingSoon = false;
                let gameDateTimeUtc = moment.utc(singleGame.data.dtegametimefixed)
                let nowUTC = moment(new Date());
                let minutesDiff = moment.duration(gameDateTimeUtc.diff(nowUTC)).asMinutes();
                // Gives a 5 minute before after the scheduled game time for the stream to turn on
                if (minutesDiff >= -5 && minutesDiff <= 60) {
                  gameStartingSoon = true;
                }

                let data = response.data;

                currentGame = singleGame.data.igameid;

                if ($scope.type === 'clip') {
                  singleGame.data = singleClip.data.game;
                }

                window.jwplayer.key = JW_PLAYER_KEY;
                $scope.player = window.jwplayer($scope.id);
                if (typeof $scope.player.setup === 'function') {
                  let playlist = [];
                  let postrollPlaylist = [];

                  let initialGame = {
                    gameId: singleGame.data.igameid,
                    audio: $scope.selectedAudio,
                    playlistData: {
                      file: data.error || !data.video ? "broadcast_unavailable.mp4" : data.video
                    }
                  };

                  if (data.error == "Game broadcast not yet available") {
                    preGameState = true;
                    initialGame.playlistData["image"] = playerPosters.notStarted;
                    if (gameStartingSoon) {
                      initialGame.playlistData["image"] = playerPosters.startingSoon;
                    }

                  } else {
                    if ($scope.type === 'game' && singleGame.data) {
                      let cookiePrerolls = $cookies.getObject('prerolls') || {};
                      let cookiePostrolls = $cookies.getObject('postrolls') || {};
                      let cookieGameId = $cookies.get('gameid');

                      if (cookieGameId === undefined) {
                        $cookies.put('gameid', $scope.origGameId);
                      }

                      if (!cookiePrerolls[singleGame.data.igameid]) {
                        if (Array.isArray(singleGame.data.preroll)) {

                          _.forEach(singleGame.data.preroll, (preroll) => {
                            playlist.push({
                              id: preroll.iprerollid,
                              file: preroll.preroll_inventory.strprerollurl
                            });
                          });

                          cookiePrerolls[singleGame.data.igameid] = playlist;
                          $cookies.putObject('prerolls', cookiePrerolls);
                        }

                        $cookies.put('gameid', $scope.origGameId);
                      }

                      if (!cookiePostrolls[singleGame.data.igameid]) {
                        if (Array.isArray(singleGame.data.postroll)) {
                          _.forEach(singleGame.data.postroll, (postroll) => {
                            postrollPlaylist.push({
                              id: postroll.iprerollid,
                              file: postroll.preroll_inventory.strprerollurl
                            });
                          });

                          cookiePostrolls[singleGame.data.igameid] = postrollPlaylist;
                          $cookies.putObject('postrolls', cookiePostrolls);
                        }

                        $cookies.put('gameid', $scope.origGameId);
                      }
                    }
                  }

                  let hasPreroll = !!playlist.length;
                  if (!hasPreroll) {
                    playlist.push(initialGame.playlistData);
                    playlist = playlist.concat(postrollPlaylist)
                  }

                  let initialPlaylistItem = $scope.player.getPlaylistItem(0);
                  if (!initialPlaylistItem || $scope.streamLoadError ||
                    ($scope.playerGameId != singleGame.data.igameid) ||
                    ((initialPlaylistItem && initialPlaylistItem.image != initialGame.playlistData.image || initialPlaylistItem.file != initialGame.playlistData.file))
                  ) {
                    $scope.player.setup({
                      playlist: playlist,
                      preload: "auto",
                      hlshtml: true,
                      width: "100%",
                      aspectratio: "16:9",
                      playbackRateControls: [0.25, 0.5, 0.75, 1, 2, 4,],
                      primary: "html5",
                      autostart: true,
                      cast: {}
                    });

                    $scope.player.setPlaybackRate(1);
                  }

                  if ($scope.type != 'clip') {
                    $scope.player.addButton(
                      '<svg id="d5e84d87-34a2-44a7-81b7-9df63ad0a3a8" class="jw-svg-icon" data-name="theater" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24,20.35H0V3.65H24ZM2.09,18.26H21.91V5.74H2.09Z"/><polygon points="6 12.5 4 12.5 4 7.5 9 7.5 9 9.5 6 9.5 6 12.5"/><polygon points="18 11.5 20 11.5 20 16.5 15 16.5 15 14.5 18 14.5 18 11.5"/></svg>',
                      "Theater Mode",
                      function () {
                        if (!$scope.theatreMode) {
                          $scope.theatreMode = true;
                          angular.element('.league-look').addClass("theatre-mode");
                          angular.element('.video-player__sidepanel').addClass("theatre-mode");
                          angular.element('.video-player__game-stats').addClass("theatre-mode");
                          angular.element('.video-player__player-lineup__lineup').addClass("theatre-mode");
                          angular.element('.video-editor__player-lineup__buttons-div').addClass("theatre-mode");
                          angular.element('.page-content').addClass("theatre-background");
                          angular.element('#d5e84d87-34a2-44a7-81b7-9df63ad0a3a8').addClass("player-icon-on");
                        } else {
                          $scope.theatreMode = false;
                          angular.element('.league-look').removeClass("theatre-mode");
                          angular.element('.video-player__sidepanel').removeClass("theatre-mode");
                          angular.element('.video-player__game-stats').removeClass("theatre-mode");
                          angular.element('.video-player__player-lineup__lineup').removeClass("theatre-mode");
                          angular.element('.video-editor__player-lineup__buttons-div').removeClass("theatre-mode");
                          angular.element('.page-content').removeClass("theatre-background");
                          angular.element('#d5e84d87-34a2-44a7-81b7-9df63ad0a3a8').removeClass("player-icon-on");
                        }
                      },
                      "theatre"
                    );
                  }

                  $scope.player.addButton(
                    '<svg id="4d01687f-062a-4000-b278-6f577db3f814" class="jw-svg-icon" data-name="forward15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="18.11 5.54 18.11 3.23 24 6.67 18.11 10.12 18.11 7.81 2.28 7.81 2.28 18.5 9.51 18.5 9.51 20.77 0 20.77 0 5.54 18.11 5.54"/><path d="M13.38,20.65h-.92V14.71c0-.5,0-1,0-1.4l-.26.25-1.36,1.11-.5-.65,2.2-1.71h.8Z"/><path d="M18.17,15.56a3.07,3.07,0,0,1,2.07.65A2.23,2.23,0,0,1,21,18a2.57,2.57,0,0,1-.82,2,3.31,3.31,0,0,1-2.28.74,4.2,4.2,0,0,1-2.15-.45v-.91a3.47,3.47,0,0,0,1,.4,5.34,5.34,0,0,0,1.17.14,2.31,2.31,0,0,0,1.56-.47A1.71,1.71,0,0,0,20,18.11c0-1.16-.71-1.75-2.14-1.75a8.72,8.72,0,0,0-1.45.17L16,16.22l.31-3.91h4.15v.88H17.07l-.21,2.5A6.54,6.54,0,0,1,18.17,15.56Z"/></svg>',
                    "Jump ahead 15s",
                    function () {
                      $scope.setPosition('+15');
                    },
                    "forward15"
                  );

                  $scope.player.addButton(
                    '<svg id="2e091f54-41cd-467c-88dc-bd2eee8e4b4d" class="jw-svg-icon" data-name="back15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="5.89 5.54 5.89 3.23 0 6.67 5.89 10.12 5.89 7.81 21.72 7.81 21.72 18.5 14.49 18.5 14.49 20.77 24 20.77 24 5.54 5.89 5.54"/><path d="M5.38,20.65H4.46V14.71c0-.5,0-1,0-1.4l-.26.25L2.88,14.67,2.38,14l2.2-1.71h.8Z"/><path d="M10.17,15.56a3.07,3.07,0,0,1,2.07.65A2.23,2.23,0,0,1,13,18a2.57,2.57,0,0,1-.82,2,3.31,3.31,0,0,1-2.28.74,4.2,4.2,0,0,1-2.15-.45v-.91a3.47,3.47,0,0,0,1,.4A5.34,5.34,0,0,0,9.91,20a2.31,2.31,0,0,0,1.56-.47A1.71,1.71,0,0,0,12,18.11c0-1.16-.71-1.75-2.14-1.75a8.72,8.72,0,0,0-1.45.17L8,16.22l.31-3.91h4.15v.88H9.07l-.21,2.5A6.54,6.54,0,0,1,10.17,15.56Z"/></svg>',
                    "Jump back 15s",
                    function () {
                      $scope.setPosition('-15');
                    },
                    "back15"
                  );

                  if ($scope.type != 'clip') {
                    $scope.player.addButton(
                      '<svg id="onOfVideoControls" class="jw-svg-icon" data-name="controls" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"/></svg>',
                      "Video Controls",
                      function () {
                        if (!$scope.showVideoControls) {
                          $scope.showVideoControls = true;
                          angular.element('#videoControls').removeClass("video-controls");
                          angular.element('#onOfVideoControls').addClass("player-icon-on");
                        } else {
                          $scope.showVideoControls = false;
                          angular.element('#videoControls').addClass("video-controls");
                          angular.element('#onOfVideoControls').removeClass("player-icon-on");
                        }
                      },
                      "video-controls"
                    );
                  }

                  $scope.player.on(
                    'ready',
                    function () {
                      playerReady = true;
                      $scope.playerRenderingMode = $scope.player.getProvider().name;

                      if ($scope.playerError) {
                        $scope.playerError = null;
                      }

                      if ($scope.refreshPlayerInterval) {
                        $interval.cancel($scope.refreshPlayerInterval);
                        $scope.refreshPlayerInterval = null;
                      }

                      if ($scope.trackWatchingInterval) {
                        $interval.cancel($scope.trackWatchingInterval);
                        $scope.trackWatchingInterval = null;
                      }

                      $scope.$parent.playerGameId = singleGame.data.igameid;
                    }
                  );

                  $scope.player.on('error', function (evt) {
                    let autoRefresh = false;
                    let JWPlayerErrorTitle = angular.element('.jw-error-msg .jw-title-primary')[0];
                    let JWPlayerErrorDesc = angular.element('.jw-error-msg .jw-title-secondary')[0];

                    let jwErrorElem = document.querySelector(".jw-error-msg");
                    jwErrorElem.style.display = "block";

                    if (data.error) {
                      $scope.$applyAsync(() => {
                        $scope.playerError = data.error;
                        hasPreroll = false;
                      });

                      if (data.error == "Game broadcast not yet available") {
                        // If the broadcast is not yet available, we show a placeholder
                        // image and want to hide the error HTML that overlays the player
                        jwErrorElem.style.display = "none";

                        autoRefresh = true;
                        hasPreroll = true;
                      }
                      else {
                        JWPlayerErrorTitle.innerHTML = data.error;
                        JWPlayerErrorDesc.innerHTML = "";
                      }
                    } else if (singleGame.data && (!singleGame.data.has_broadcast || singleGame.data.blivegameflag > 2)) {
                      let gameCancelledMessage = "This broadcast has been cancelled.";

                      $scope.$applyAsync(() => {
                        $scope.playerError = gameCancelledMessage;
                        hasPreroll = false;
                      });

                      JWPlayerErrorTitle.innerHTML = gameCancelledMessage;
                      JWPlayerErrorDesc.innerHTML = "";
                    } else {
                      if (gameStartingSoon) {
                        $scope.$parent.streamLoadError = true;
                        autoRefresh = true;
                        preGameState = true;
                      }

                      switch (evt.message) {
                        case "Error loading player: No playable sources found":
                        case "Cannot load M3U8: 404 Not Found":
                          $scope.$applyAsync(() => {
                            $scope.playerError = evt.message;
                            hasPreroll = false;
                          });
                          break;
                      }
                    }

                    if (autoRefresh) {
                      if (!$scope.refreshPlayerInterval) {
                        $scope.refreshPlayerInterval = $interval(loadMedia, 30000);
                      }
                    }
                  });

                  if (hasPreroll) {
                    $scope.player.once(
                      'playlistComplete',
                      () => {
                        //Once the game is completely loaded we need to seek to the start time (if applicable)
                        //The game is the first item after the preroll playlist is complete
                        $scope.player.once(
                          'play',
                          () => {
                            if ($scope.type === 'game' && singleGame.data && singleGame.data.istarttime) {
                              $scope.player.seek(singleGame.data.istarttime);
                            } else if ($scope.type === 'clip' && singleClip.data) {
                              let startTime = singleClip.transformer.getStartTime(singleClip.data);
                              $scope.player.seek(startTime);
                            }
                          }
                        );
                        $scope.player.load([initialGame.playlistData].concat(postrollPlaylist));
                        if ($scope.type === 'game') {
                          // If playlistData["image"] is defined, the stream is not actually playing, so we won't call logPlayed
                          if (!initialGame.playlistData["image"]) {
                            singleGame.logPlayed(initialGame.gameId, initialGame.audio).then(function (response) {
                              if (response.status == 200) {
                                $scope.watchedGameId = response.data.id;
                                if (!$scope.trackWatchingInterval) {
                                  $scope.trackWatchingInterval = $interval(trackWatching, $scope.trackWatchingIntervalTime);
                                }
                              }
                            });
                          }
                        } else if ($scope.type === 'clip') {
                          singleClip.logWatched();
                        }
                      }
                    );

                    $scope.player.once(
                      'error',
                      () => {
                        $scope.player.load([initialGame.playlistData]);
                        if ($scope.type === 'clip') {
                          singleClip.logWatched();
                        }
                      }
                    );
                  } else {
                    //Once the game is completely loaded we need to seek to the start time (if applicable)
                    //The game is the first item in the player
                    $scope.player.once(
                      'ready',
                      function () {
                        if ($scope.type == 'game' && singleGame.data && singleGame.data.istarttime) {
                          $scope.player.seek(singleGame.data.istarttime);
                        } else if ($scope.type === 'clip' && singleClip.data) {
                          let startTime = singleClip.transformer.getStartTime(singleClip.data);
                          $scope.player.seek(startTime);
                        }
                      }
                    );
                    switch ($scope.type) {
                      case 'game':
                        // If playlistData["image"] is defined, the stream is not actually playing, so we won't call logPlayed
                        if (!initialGame.playlistData["image"]) {
                          singleGame.logPlayed(initialGame.gameId, initialGame.audio).then(function (response) {
                            if (response.status == 200) {
                              $scope.watchedGameId = response.data.id;
                              if (!$scope.trackWatchingInterval) {
                                $scope.trackWatchingInterval = $interval(trackWatching, $scope.trackWatchingIntervalTime);
                              }
                            }
                          });
                        }
                        break;
                      case 'clip':
                        singleClip.logWatched();
                        break;
                    }
                  }
                }
              }
            });
          }
        }
      };

      let init = function () {
        $scope.$watch('enableHotKeys', function (enable) {
          $scope.$broadcast('enableHotKeys', enable)
        });
      };

      let playSpeedsFast = [{
        txt: '2x',
        mult: '*2',
      }, {
        txt: '4x',
        mult: '*4',
      }, {
        txt: '8x',
        mult: '*8',
      }];

      let playSpeedsSlow = [{
        txt: '0.75x',
        mult: '*0.75',
      }, {
        txt: '0.50x',
        mult: '*0.5',
      }, {
        txt: '0.25x',
        mult: '*0.25',
      }];

      $scope.playSpeed = { speed: 'normal', index: 0 }; //'normal', 'slow', 'fast'

      $scope.playSpeedsFastTxt = playSpeedsFast[0].txt;
      $scope.playSpeedsSlowTxt = playSpeedsSlow[0].txt;

      $scope.enableHotKeys = true;

      $scope.instantReplay = function (params) {
        if ($scope.player) {
          $scope.disableEventButtons = true;
          let categoryId = null;
          let options = {
            debug: {
              jwplayer_version: $scope.player.version
            }
          };

          if (angular.isObject(params)) {
            categoryId = params.category_id;
            if (angular.isObject(params.options)) options = params.options;
          } else {
            categoryId = params;
          }

          let clipOffset;

          clipOffset = window.jwPlayerMod.cursorOffset($scope.player);

          if (clipOffset !== false) {
            Object.assign(options, window.jwPlayerMod.fragPosition($scope.player));
            if ($scope.selectedAudio) {
              options["audio"] = $scope.selectedAudio;
            } else {
              options["audio"] = singleGame.data.pixellot_only ? 4 : 1;
            }

            singleGame.createInstantReplay(clipOffset, categoryId, options)
              .then((response) => {
                let data = response.data;

                if (!data.error) {
                  let params = {
                    show_editor: false,
                    clip: data
                  };

                  if (!singleGame.data.is_live) {
                    $scope.player.seek(data.strsourcestart);
                  }

                  $scope.$broadcast('instant_replay_created', params);
                  $scope.$broadcast('assign_timeline_clips');
                }
              });
          }

          $timeout(function () {
            $scope.disableEventButtons = false;
          }, 1000);
        }
      };

      eventListeners.push(
        $rootScope.$on('set_instant_replay', function (event, data) {
          $scope.instantReplay(data);
        })
      );

      $scope.toggleLike = function (clip) {
        switch ($scope.type) {
          case 'clip':
            singleClip.toggle_like(clip.data.iclipid)
              .then(function (response) {
                let data = response.data;

                let likes = parseInt(data.likes);
                if (isNaN(likes)) {
                  likes = 0;
                }
                clip.data.likes = likes;
                clip.data.i_like = data.i_like;
              });
            break;
        }
      };

      $scope.flagInappropriate = (clip) => {
        switch ($scope.type) {
          case 'clip':
            let confirmed = confirm('Mark this clip as inappropirate?');
            if (confirmed) {
              singleClip.flagInappropriate(clip.data.iclipid)
                .then(() => {
                  $state.reload();
                });
            }
        }
      };

      $scope.normalPlaySpeed = function () {
        $scope.playSpeed.speed = 'normal';
        $scope.playSpeed.index = 0;

        $scope.setSpeed(1);

        $scope.playSpeedsFastTxt = playSpeedsFast[0].txt;
        $scope.playSpeedsSlowTxt = playSpeedsSlow[0].txt;
      };

      $scope.increasePlaySpeed = function () {
        $scope.setSpeed(1);

        if ($scope.playSpeed.speed === 'fast') {

          if (parseInt($scope.playSpeed.index) === (playSpeedsFast.length - 1)) {
            $scope.playSpeed.index = 0;
          } else {
            $scope.playSpeed.index = $scope.playSpeed.index + 1;
          }

        } else {
          $scope.playSpeed.speed = 'fast';
          $scope.playSpeed.index = 0;
        }

        $scope.setSpeed(playSpeedsFast[$scope.playSpeed.index].mult);

        $scope.playSpeedsFastTxt = playSpeedsFast[$scope.playSpeed.index].txt;
        $scope.playSpeedsSlowTxt = playSpeedsSlow[0].txt;

      };

      $scope.decreasePlaySpeed = function () {
        $scope.setSpeed(1);

        if ($scope.playSpeed.speed === 'slow') {

          if (parseInt($scope.playSpeed.index) === (playSpeedsSlow.length - 1)) {
            $scope.playSpeed.index = 0;
          } else {
            $scope.playSpeed.index = $scope.playSpeed.index + 1;
          }

        } else {
          $scope.playSpeed.speed = 'slow';
          $scope.playSpeed.index = 0;
        }

        $scope.setSpeed(playSpeedsSlow[$scope.playSpeed.index].mult);

        $scope.playSpeedsSlowTxt = playSpeedsSlow[$scope.playSpeed.index].txt;
        $scope.playSpeedsFastTxt = playSpeedsFast[0].txt;
      };

      $scope.setSpeed = function (newRate) {
        if ($scope.playerRenderingMode === 'html5' || $scope.playerRenderingMode === 'hlsjs') {
          let videoTag = document.querySelector('video');
          let currentRate = videoTag.playbackRate;
          if (currentRate) {
            if (typeof newRate === 'string' && newRate.match(/^\*/)) {
              newRate = currentRate * parseFloat(newRate.replace(/^\*/, ''));
            }
            else {
              newRate = parseFloat(newRate);
            }
          }
          else {
            newRate = 1;
          }

          videoTag.playbackRate = newRate;
          videoTag.defaultPlaybackRate = 1;
        }
      };

      $scope.setPosition = function (newPosition) {
        if (typeof newPosition === 'string' && newPosition.match(/^[+\-]/)) {
          let currentPosition = $scope.player.getPosition();
          let operator = newPosition.substr(0, 1);
          let positionOffset = parseFloat(newPosition.replace(/^[+\-]/, ''));
          switch (operator) {
            case '+':
              newPosition = currentPosition + positionOffset;
              break;
            case '-':
              newPosition = currentPosition - positionOffset;
              break;
          }
        }
        else {
          newPosition = parseFloat(newPosition);
        }

        $scope.player.seek(newPosition);
      };

      let trackWatching = function () {
        if ($scope.watchedGameId && $scope.player.getState() == "playing") {
          singleGame.updatePlayedTime($scope.watchedGameId);
        }
      }

      eventListeners.push(
        $scope.$on('singleGameReady', function () {
          $scope.watchedGameId = null;
          gameReady = true;
        })
      );

      $scope.$watch(
        function () {
          if (!domReady) {
            domReady = !!document.getElementById($scope.id);
          }
          return domReady && gameReady;
        },
        function () {
          loadMedia();
        }
      );

      $scope.$watch(
        function () {
          if ($scope.type === 'clip') {
            if (singleClip.data) {
              return singleClip.data.iclipid;
            }
          }
          return null;
        },
        function () {
          loadMedia();
        }
      );

      $scope.$watch(
        function () {
          if ($scope.type === 'game') {
            if (singleGame.data) {
              return singleGame.data.igameid;
            }
          }
          return null;
        },
        function () {
          loadMedia();
        }
      );

      init();

      $scope.$on('$destroy', () => {
        _.invokeMap(eventListeners, _.call);
        $interval.cancel($scope.refreshPlayerInterval);
        $interval.cancel($scope.trackWatchingInterval);
      });
    }
  ])
  ;


// WEBPACK FOOTER //
// ./app.v2/components/player/jwPlayer/jwPlayerController.js